"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnWidthOptions = void 0;
exports.ColumnWidthOptions = Object.freeze({
    NARROW: 'narrow',
    MEDIUM: 'medium',
    WIDE: 'wide',
    FLEX: 'flex',
});
